<div class="product-cell">
  <!-- Icon and Product Details -->
  <div class="left-section">
    <glxy-avatar [width]="40" [name]="name" [src]="iconUrl"></glxy-avatar>
    <div class="product-name-type">
      @if (!!fulfillmentStatus) {
        <a class="product-name-hyperlink" (click)="handleWorkOrdersLinkClicked()">
          {{ name }}
        </a>
      } @else {
        <div>
          {{ name }}
        </div>
      }
      <div class="subtext">
        @if ((type | formatAppType) === 'Add-on') {
          <div>Add-on to {{ parentName }}</div>
        } @else {
          <div>Product</div>
        }
      </div>
    </div>
  </div>

  <!-- Status Badge and Menu -->
  <div class="right-section">
    <div class="status-section">
      @if (!!fulfillmentStatus) {
        @if (fulfillmentStatus | getFulfillmentBadgeData: badgeColors : persona; as badgeData) {
          <glxy-badge [color]="badgeData.color">
            {{ badgeData.status | translate }}
          </glxy-badge>
        }
      }
      @if (activationStatus === ActivationStatus.ACTIVATED) {
        <glxy-badge [color]="'green'">{{ 'LIB_ORDERS.FULFILLMENT_STATUS.ACTIVATED' | translate }}</glxy-badge>
      } @else if (activationStatus === ActivationStatus.ERRORED) {
        <glxy-badge
          [color]="'red'"
          (mouseenter)="errorPopover.open()"
          (mouseleave)="errorPopover.close()"
          [glxyPopover]="errorPopover"
        >
          {{ 'LIB_ORDERS.FULFILLMENT_STATUS.ERRORED' | translate }}
        </glxy-badge>
      } @else if (activationStatus === ActivationStatus.ALREADY_ACTIVATED) {
        <glxy-badge [color]="'red'">{{ 'LIB_ORDERS.FULFILLMENT_STATUS.ALREADY_ACTIVATED' | translate }}</glxy-badge>
      } @else if (activationStatus === ActivationStatus.IGNORED_ERRORS) {
        <glxy-badge [color]="'grey'">{{ 'LIB_ORDERS.FULFILLMENT_STATUS.IGNORED_ERRORS' | translate }}</glxy-badge>
      } @else if (activationStatus === ActivationStatus.SCHEDULED) {
        <glxy-badge [color]="'blue'">{{ 'LIB_ORDERS.FULFILLMENT_STATUS.SCHEDULED' | translate }}</glxy-badge>
      } @else if (activationStatus === ActivationStatus.UNSCHEDULED) {
        <glxy-badge [color]="'grey'">{{ 'LIB_ORDERS.FULFILLMENT_STATUS.UNSCHEDULED' | translate }}</glxy-badge>
      } @else if (activationStatus !== ActivationStatus.CANCELED) {
        <glxy-badge [color]="'blue'">{{ 'LIB_ORDERS.FULFILLMENT_STATUS.PENDING' | translate }}</glxy-badge>
      }
    </div>

    <ng-container *ngTemplateOutlet="menu"></ng-container>
  </div>
</div>

<glxy-popover #errorPopover>
  <div>{{ activationErrorDetails }}</div>
</glxy-popover>

<ng-template #menu>
  <div class="menu-container">
    @if (menuItems && menuItems.length > 0) {
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @for (menuItem of menuItems; track menuItem) {
          <button mat-menu-item (click)="menuItemClick(menuItem)">
            @if (!!menuItem.icon) {
              <mat-icon>{{ menuItem.icon }}</mat-icon>
            }
            {{ menuItem.label | translate }}
          </button>
        }
      </mat-menu>
    }
  </div>
</ng-template>
